import api from "@/services/axiosInstance";

const API_BASE_URL = process.env.VUE_APP_BACKEND_URL;
const content = "crm";
const version = "v1";

// customers
export const fetchV1Customers = async (page = 1, pageSize = 5) => {
  page = page ?? 1;
  pageSize = pageSize ?? 8;
  let URL = `${API_BASE_URL}/${content}/${version}/customers/?page_size=${pageSize}&page=${page}`;

  console.log("customers API:", URL, page, pageSize);

  try {
    const response = await api.get(URL);
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

export const createV1Customer = async (data) => {
  const URL = `${API_BASE_URL}/${content}/${version}/customers/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error creating Customer at service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied!" };
    }

    throw error;
  }
};

export const getOrCreateV1Customer = async (data) => { 
  const URL = `${API_BASE_URL}/${content}/${version}/customers/get-or-create/`;
  try {
    const response = await api.post(URL, data);
    return response.data;
  } catch (error) {
    console.error("Error @ get or create customer service:", error);

    if (error.response && error.response.status === 403) {
      return { error: true, message: "Permission denied!" };
    }

    throw error;
  }
};